const steps = [
  { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Анализ текущей ситуации: какие KPI важны для бизнеса, что нужно улучшить, где «болит». Определение целей обучения в цифрах.' },
  { icon: 'ri-focus-3-line', title: 'Цели бизнеса', desc: 'Связываем цели обучения с бизнес-показателями. Не «научить продавать», а «поднять конверсию с 14% до 20% за 3 месяца».' },
  { icon: 'ri-bar-chart-2-line', title: 'Замер KPI', desc: 'Фиксируем базовый уровень по всем целевым метрикам: конверсия, средний чек, длина сделки, NPS, текучесть. Это точка отсчёта.' },
  { icon: 'ri-graduation-cap-line', title: 'Обучение', desc: 'Проводим тренинг или программу обучения с отработкой навыков, кейсами из практики компании и реальными инструментами.' },
  { icon: 'ri-tools-line', title: 'Практика', desc: 'Отработка навыков на реальных рабочих ситуациях. Участники применяют новые инструменты под наблюдением.' },
  { icon: 'ri-file-list-3-line', title: 'Домашние задания', desc: 'Конкретные задачи с дедлайнами: внедрить скрипт, провести 10 встреч по новой методике, подготовить отчёт.' },
  { icon: 'ri-user-heart-line', title: 'Сопровождение', desc: 'Регулярная связь с руководителями и участниками: ответы на вопросы, разбор сложных кейсов, корректировка.' },
  { icon: 'ri-refresh-line', title: 'Повторный замер KPI', desc: 'Через 1-3 месяца замеряем те же метрики. Сравниваем с базовым уровнем. Видим реальный эффект в цифрах.' },
  { icon: 'ri-file-chart-line', title: 'Отчёт руководителю', desc: 'Предоставляем руководителю отчёт с цифрами: что было, что стало, какой ROI. Обучение становится прозрачной инвестицией.' },
];

export default function HowIEvaluate() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как я оцениваю эффективность обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Авторская методология оценки: 9 шагов от диагностики до отчёта. Каждый шаг создаёт основу для следующего — пропустить нельзя, иначе система не работает.
        </p>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-0">
            {steps.map((s, i) => (
              <div key={i} className="relative">
                <div className="flex items-start gap-5 pb-8">
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center z-10 relative">
                      <span className="text-white font-bold">{i + 1}</span>
                    </div>
                    {i < steps.length - 1 && (
                      <div className="w-0.5 h-full bg-teal-300 absolute top-12"></div>
                    )}
                  </div>
                  <div className="flex-1 bg-gray-50 rounded-xl p-5 border border-gray-100">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                        <i className={`${s.icon} text-sm text-teal-600`}></i>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">{s.title}</h3>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}